import { useState, useEffect, useCallback, useRef } from 'react';

const MOBILE_BREAKPOINT = 768;

export function useIsMobile(): boolean {
    const [isMobile, setIsMobile] = useState(
        () => window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches
    );
    const timeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);

    const handleChange = useCallback(() => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
            setIsMobile(window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches);
        }, 150);
    }, []);

    useEffect(() => {
        const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
        mql.addEventListener('change', handleChange);
        return () => {
            mql.removeEventListener('change', handleChange);
            clearTimeout(timeoutRef.current);
        };
    }, [handleChange]);

    return isMobile;
}
